import React, { useEffect, useState } from 'react';

import { MenuItem, Select } from '@material-ui/core';
import clsx from 'clsx';

import DocumentTitle from 'components/DocumentTitle';
import Header from 'components/Header';
import ListTable from 'components/ListTable';

import { LOANS_STATUSES } from 'const';

import { useGetExtendedLoansQuery } from 'domain/extendedLoan/apiSlice';
import { UpcomingMaturitiesService } from 'domain/extendedLoan/service';

import { useErrors } from 'hooks/useErrors';
import { useRefElementHeight } from 'hooks/useRefElementHeight';

import ContentLayout from 'layouts/ContentLayout';
import RootLayoutV2 from 'layouts/RootLayoutV2';

import { appRoutes } from 'router/routes';

import { defaultMonthSelectValue, monthSelectValues } from 'utils/date';
import { getHomeLinks } from 'utils/routes';

import useStyles from './useStyles';

const TITLE = 'Upcoming Maturities';

export const HomeUpcomingMaturities = () => {
  const classes = useStyles();
  const { displayErrorsInToast } = useErrors();
  const { elementRef: header, elementHeight } = useRefElementHeight();

  const [selectedMonth, selectMonth] = useState(defaultMonthSelectValue);

  const fetchingParams = {
    maturityOnly: 1,
    ordering: 'par_repay_date,maturity_date',
    status: LOANS_STATUSES.activeInPayment,
    nextMonths: selectedMonth,
  };

  const {
    data,
    isFetching: areUpcomingMaturitiesLoading,
    isError: isUpcomingMaturitiesLoadError,
    error: upcomingMaturitiesLoadError,
  } = useGetExtendedLoansQuery(fetchingParams);

  const tableData = UpcomingMaturitiesService.getTableData(data);
  const columnsKeys = UpcomingMaturitiesService.getColumnsKeys();
  const { upcomingMaturitiesColumnConfig } = UpcomingMaturitiesService;

  const monthSelectOnChange = e => {
    selectMonth(e.target.value);
  };

  useEffect(() => {
    if (isUpcomingMaturitiesLoadError) {
      displayErrorsInToast([upcomingMaturitiesLoadError]);
    }
  }, [isUpcomingMaturitiesLoadError]);

  const sideBarContent = getHomeLinks();

  return (
    <RootLayoutV2 sideBarContent={sideBarContent}>
      <ContentLayout disableTopPadding>
        <DocumentTitle title={TITLE} />
        <Header title={TITLE} ref={header}>
          <div className={classes.actionPanel}>
            <Select
              className={clsx(classes.monthSelect, classes.actionPanelSelect)}
              variant="standard"
              name="monthSelect"
              displayEmpty
              defaultValue={selectedMonth}
              onChange={monthSelectOnChange}
            >
              {monthSelectValues.map(month => (
                <MenuItem className={classes.menuItem} key={`month_${month}`} value={month}>
                  {month} Months
                </MenuItem>
              ))}
              <MenuItem className={classes.menuItem} value={null}>
                All
              </MenuItem>
            </Select>
          </div>
        </Header>
        <ListTable
          detailPath={appRoutes.loanPath}
          isLoading={areUpcomingMaturitiesLoading}
          tableHeader={columnsKeys}
          tableData={tableData}
          columnConfig={upcomingMaturitiesColumnConfig}
          isOuterScrollable
          fixedTopOffset={elementHeight}
        />
      </ContentLayout>
    </RootLayoutV2>
  );
};
